import React from "react";
import { DeprecatedSpinner } from "components/Spinner";
import { wrapper, loadingText } from "./Loading.css";

type Props = {
  message: string;
};

export const Loading: React.FC<Props> = ({ message }) => {
  return (
    <div className={wrapper}>
      <DeprecatedSpinner />
      <p className={loadingText}>{message}</p>
    </div>
  );
};
